import type { AssessmentTest } from '@entities/assessment'

import { questions as questionsMath } from '../questions/math/grade-k3'
import { questions as questionsEla } from '../questions/ela/grade-k3'
import { questionsTest as questionsElaTest } from '../questions/ela/grade-k3-test'

export const configK3: AssessmentTest = {
  title: 'Grade 3 math assessment',
  quizTitle: 'Math assessment',
  description: 'Let your discipline complete this assessment test independently. Don’t worry if they can’t answer some of the questions—that’s totally fine!',
  quizTitleCheckUp: 'Math check-up',
  descriptionCheckUp: 'Let your child complete this quick test independently. Don’t worry if they can’t answer some of the questions — that’s totally fine!',
  questions: questionsMath,
}

export const configK3Ela: AssessmentTest = {
  title: 'Grade 3<br> reading assessment',
  quizTitle: 'Reading assessment',
  description: 'Let your discipline complete this assessment test independently. Don’t worry if they can’t answer some of the questions—that’s totally fine!',
  quizTitleCheckUp: 'Comprehension check-up',
  descriptionCheckUp: 'Let your child complete this quick test independently. Don’t worry if they can’t answer some of the questions — that’s totally fine!',
  questions: questionsEla,
}

export const configK3ElaTest: AssessmentTest = {
  title: 'Grade 3<br> reading assessment',
  quizTitle: 'Reading assessment',
  description: 'Let your discipline complete this assessment test independently. Don’t worry if they can’t answer some of the questions—that’s totally fine!',
  quizTitleCheckUp: 'Comprehension check-up',
  descriptionCheckUp: 'Let your child complete this quick test independently. Don’t worry if they can’t answer some of the questions — that’s totally fine!',
  questions: questionsElaTest,
}
